export {
  StudentIdReactFeature,
  studentIdReactFeature,
  StudentIdReactFeature as default,
} from './StudentIdReactFeature'
